import * as Types from '../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSalesProfileInfoMutationVariables = Types.Exact<{
  employeeId: Types.Scalars['String']['input'];
}>;


export type DeleteSalesProfileInfoMutation = { __typename?: 'Mutation', deleteSalesProfileInfo: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const DeleteSalesProfileInfoDocument = gql`
    mutation DeleteSalesProfileInfo($employeeId: String!) {
  deleteSalesProfileInfo(employeeId: $employeeId) {
    count
    error
  }
}
    `;
export type DeleteSalesProfileInfoMutationFn = Apollo.MutationFunction<DeleteSalesProfileInfoMutation, DeleteSalesProfileInfoMutationVariables>;

/**
 * __useDeleteSalesProfileInfoMutation__
 *
 * To run a mutation, you first call `useDeleteSalesProfileInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesProfileInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesProfileInfoMutation, { data, loading, error }] = useDeleteSalesProfileInfoMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteSalesProfileInfoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesProfileInfoMutation, DeleteSalesProfileInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesProfileInfoMutation, DeleteSalesProfileInfoMutationVariables>(DeleteSalesProfileInfoDocument, options);
      }
export type DeleteSalesProfileInfoMutationHookResult = ReturnType<typeof useDeleteSalesProfileInfoMutation>;
export type DeleteSalesProfileInfoMutationResult = Apollo.MutationResult<DeleteSalesProfileInfoMutation>;
export type DeleteSalesProfileInfoMutationOptions = Apollo.BaseMutationOptions<DeleteSalesProfileInfoMutation, DeleteSalesProfileInfoMutationVariables>;